export default __webpack_public_path__ + "static/media/Group 35899.499f9dbe.svg";